<div class="table-detail-container">
  <div class="header">
    <h2>{{ notificationInfo.title || 'Table Details' }}</h2>
    <p class="notification-body" *ngIf="notificationInfo.body">{{ notificationInfo.body }}</p>
  </div>

  <div class="error" *ngIf="error && !loading()">
    <div class="error-card">
      <h3>{{ 'GLOBAL.ERROR' | translate }}</h3>
      <p>{{ error }}</p>
    </div>
  </div>

  <div class="content" *ngIf="!loading() && !error; else loadingTemplate">
    <div class="table-card">
      <div class="table-header">
        <h3>{{ tableData.title }}</h3>
        <span class="record-count">{{ tableData.totalCount }} {{ 'TABLES.ENTRIES' | translate }}</span>
      </div>

      <div class="table-container" *ngIf="tableData.totalCount > 0; else noDataTemplate">
        <table class="data-table">
          <thead>
            <tr>
              <th *ngFor="let column of tableData.columns">
                {{ column.name }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of tableData.rows; trackBy: trackByIndex">
              <td *ngFor="let column of tableData.columns" [class]="'type-' + column.type">
                {{ formatCellValue(row[column.key], column.type) | translate}}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <ng-template #noDataTemplate>
        <div class="no-data">
          <p>{{ 'TABLES.NO_DATA' | translate }}</p>
        </div>
      </ng-template>
    </div>

    <div class="metadata" *ngIf="notificationInfo.created">
      <small>{{ 'GLOBAL.CREATED' | translate }} {{ notificationInfo.created | date:'dd.MM.yyyy HH:mm' }}</small>
    </div>
  </div>

  <ng-template #loadingTemplate>
    <div class="loading">
      <div class="loading-spinner"></div>
      <p>{{ 'TABLES.LOADING_DATA' | translate }}</p>
    </div>
  </ng-template>
</div>